export const getAbsoluteValue = (string) => {
  const newString = string.replaceAll(",", "");
  return parseInt(newString);
};

export const getFormattedString = (value) => {
  if (value > 999) {
    const stringArr = value.toString().split("").reverse();
    const newStringArr = stringArr.map((digit, index) => {
      if (index === 2) return `,${digit}`;
      else return digit;
    });
    const newString = newStringArr.reverse().join("");
    return newString;
  } else if (value < 10) return `0${value}`;
  else return value.toString();
};
